import { createFileRoute } from '@tanstack/react-router';
import { ShiftSwapsPage } from '@/features/shift-swaps/ShiftSwapsPage';

/**
 * Scambi turno fra colleghi (BE `shift-swap-requests`, contratto SHIFT-SWAP v1, 10 set 2026).
 * Il componente sta in `features/shift-swaps/`: una pagina dentro il file di rotta non si monta in un
 * test senza finta del router.
 */
export const Route = createFileRoute('/_app/shift-swaps')({ component: ShiftSwapsPage });
